import { ReportControllerBaseConfig } from '../../../../base';
import { ReportLayoutController } from './reportLayoutInterface';

export function createReportLayoutController(
    config: ReportControllerBaseConfig
): ReportLayoutController {
    const {
        kernel: {
            adapter: { help },
        },
    } = config;
    return {
        useProps(context, item, props) {
            return {
                detail: {
                    container: {
                        isVisible: props.detail.value,
                    },
                    button: {
                        onClick: props.detail.onChange.bind(null, !props.detail.value),
                    },
                },
                help: {
                    button: {
                        onClick() {
                            help.open();
                        },
                    },
                },
                link: {
                    back: { to: props.returnPath ?? '/u' },
                    home: { to: '/u' },
                },
            };
        },
    };
}
